import {useState,useEffect,useRef} from 'react';

const Createrole = () =>{
   const [initialvalues,setValues] = useState();

   const handleChanges = (event) =>{
       setValues((prevdata)=>{
            return {
                prevdata,
                [event.target.name]: event.target.value    
            }
       }) 
   }

   const createrole = () =>{
      console.log("initial values"); 
      console.log(initialvalues);
   }  



   return (
      <>
          <div className="card">
           <form onSubmit={(e)=>createrole(e)}>
            <div class="row">
                <div className="col-md-3"> 
                 <div class="form-group">
                    <label for="name">Role Name</label>
                    <input
                        type="text"
                        class="form-control"
                        id="name"
                        name="name"
                        placeholder="Role name"
                        onChange={handleChanges}
                    />
                 </div>
                </div>
                
                <div className="col-md-3">
                   <div style={{marginTop:'26px'}}></div> 
                   <div class="form-group">
                      <button className="btn btn-success btn-round" type="submit">Save</button>
                   </div>
                </div>
                
                 </div>
               </form>
             </div>   
      </>
   );   
}

export default Createrole;